// The PO wizard serves both /inventory/purchase-orders/new and /:id/edit; every
// visible label must say which one the user is on (PU2-004).
export function poFormLabels(isEditing: boolean, poNumber?: string) {
  if (!isEditing) {
    return {
      title: 'Create Purchase Order',
      crumb: 'New',
      subtitle: 'Add a new vendor purchase order for stock replenishment',
      submit: 'Create Purchase Order',
      submitting: 'Creating...',
    };
  }
  return {
    title: poNumber ? `Edit Purchase Order ${poNumber}` : 'Edit Purchase Order',
    crumb: poNumber ? `Edit ${poNumber}` : 'Edit',
    subtitle: 'Change this draft purchase order',
    submit: 'Save changes',
    submitting: 'Saving...',
  };
}
